import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createComment({ commit }, item) {
    return this.$axios.$post('admin/comments/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeComment({ commit }, item) {
    return this.$axios.$delete(`admin/comments/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateComment({ commit }, item) {
    return this.$axios.$put(`admin/comments/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchComment({ commit }, id) {
    return this.$axios.$get(`admin/comments/${id}`).then((response) => {
      return response.data
    })
  },
  fetchComments({ commit }) {
    return this.$axios.$get('admin/comments').then((response) => {
      commit('load', response.data)
      return response.data
    })
  },
}
